import { Level2MenuHead, Level2MenuItem } from "@/features";
import { IoSettingsOutline } from "react-icons/io5";
import { IoMdKey } from "react-icons/io";
import React, { ReactElement, useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import type { GgMeType } from "@/types";
import {
  getRoleTypeNameFromUser,
  permissionsUsersReadonly,
  permissionsRolesReadonly,
  permissionsCompaniesReadonly,
  permissionsPartnersReadonly,
  permissionsTenantsReadonly,
  permissionsSubscriptionsReadonly,
  permissionsSystemMenu,
  permissionsLocationsReadonly,
} from "@/utils";

const parentPath = "system-admin";

interface SystemMenuProps {
  user?: GgMeType | null;
}

export const SystemMenu = ({ user }: SystemMenuProps): ReactElement | null => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const roleType = getRoleTypeNameFromUser(user);

  if (roleType !== "super" && roleType !== "system") {
    return null;
  }

  return (
    <Level2MenuHead
      link={`/${parentPath}`}
      label={roleType === "system" ? gettext("Settings") : gettext("System")}
      codes={permissionsSystemMenu}
      feature="common"
      icon={
        <>
          {roleType === "system" && (
            <IoSettingsOutline size={18} className="mx-3" />
          )}
          {roleType !== "system" && <IoMdKey size={18} className="mx-3" />}
        </>
      }
    >
      <Level2MenuItem
        link={`/${parentPath}/all-users`}
        label={gettext("Users")}
        codes={permissionsUsersReadonly}
        feature="common"
      />

      {/* <Level2MenuItem
        link={`/${parentPath}/system-users`}
        label={gettext("System Users")}
        codes={permissionsUsersReadonly}
        feature="common"
      /> */}

      <Level2MenuItem
        link={`/${parentPath}/roles`}
        label={gettext("Roles")}
        codes={permissionsRolesReadonly}
        feature="common"
      />

      <Level2MenuItem
        link={`/${parentPath}/partners`}
        label={gettext("Partners")}
        codes={permissionsPartnersReadonly}
        feature="common"
      />

      <Level2MenuItem
        link={`/${parentPath}/tenants`}
        label={gettext("Corporate Groups")}
        codes={permissionsTenantsReadonly}
        feature="common"
      />

      <Level2MenuItem
        link={`/${parentPath}/companies`}
        label={gettext("Companies")}
        codes={permissionsCompaniesReadonly}
        feature="common"
      />

      <Level2MenuItem
        link={`/${parentPath}/locations`}
        label={gettext("Company Location")}
        codes={permissionsLocationsReadonly}
        feature="common"
      />

      <Level2MenuItem
        link={`/${parentPath}/subscriptions`}
        label={gettext("Subscription Plans")}
        codes={permissionsSubscriptionsReadonly}
        feature="common"
      />

      <Level2MenuItem
        link={`/${parentPath}/data-limits`}
        label={gettext("Historical Data")}
        codes={permissionsSubscriptionsReadonly}
        feature="common"
      />

      <Level2MenuItem
        link={`/${parentPath}/settings`}
        label={gettext("Settings")}
        codes={permissionsSystemMenu}
        feature="common"
      />
    </Level2MenuHead>
  );
};
